export default __webpack_public_path__ + "static/media/shield-lock-outline.e6412c3e.svg";